<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "SecretKeys",
  data() {
    return {
      loading: false,
      dataList: [],
      excelForm: {
        board_id: null,
        intention: "MY_SCHOOL_PHONE_NUMBER_CHANGE",
        from_date: null,
        to_date: null,
        application_status: "PENDING",
      },
      intentions: [
        {
          value: "MY_SCHOOL_PHONE_NUMBER_CHANGE",
          label: "Telefon raqamni o'zgartirish",
        },
        {
          value: "MY_SCHOOL_SEND_SECRET_AGAIN",
          label: "Kalitni qayta yuborish",
        },
      ],
      application_statuses: [
        { value: "APPROVED", label: "Muvaffaqiyatli" },
        { value: "REJECTED", label: "Rad etilgan" },
        { value: "PENDING", label: "Jarayonda" },
      ],
      excelModalVisible: false,
      totalElements: 0,
      totalPages: null,
      size: 18,
      page: 1,
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/my-school/secret-keys/excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      boards: [],
      selectedBoardId: null,
      excelRules: {
        board_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        intention: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        from_date: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        to_date: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        application_status: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
    dateRange: {
      get() {
        if (this.excelForm.from_date && this.excelForm.to_date) {
          return [this.excelForm.from_date, this.excelForm.to_date];
        }
        return null;
      },
      set(value) {
        if (value && value.length === 2) {
          this.excelForm.from_date = value[0];
          this.excelForm.to_date = value[1];
        } else {
          this.excelForm.from_date = null;
          this.excelForm.to_date = null;
        }
      },
    },
  },
  methods: {
    onChangeBoard() {
      this.$router.replace({
        query: { ...this.$route.query, page: 1, board: this.selectedBoardId },
      });
      this.getSchoolSecretKeys();
    },

    onSubmitExcel() {
      this.$refs.excelForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            ...this.excelForm,
            from_date: this.excelForm.from_date
              ? this.$moment(this.excelForm.from_date).toISOString()
              : null,
            to_date: this.excelForm.to_date
              ? this.$moment(this.excelForm.to_date).toISOString()
              : null,
          };
          this.$http
            .get(`api/v1/modification-requests/excel`, {
              params: params,
              responseType: "blob",
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              let fileName = "modification-requests.xlsx";
              if (header) {
                const parts = header.split(";");
                if (parts.length > 1) {
                  fileName = parts[1].split("=")[1];
                }
              }
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              ElNotification.success({
                message: "Excel muvaffaqiyatli yuklandi!",
              });
              this.handleClose();
            })
            .catch((err) => {
              ElNotification.error({
                message:
                  err.response?.data?.message ||
                  "Excel yuklashda xatolik sodir bo'ldi!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    getBoards() {
      this.loading = true;
      this.$http
        .get(`api/v1/my-school/boards`, {
          params: { status: 1, offset: 0, limit: 1000 },
        })
        .then(({ data }) => {
          this.boards = data.boards;
          if (this.$route.query.board) {
            this.selectedBoardId = parseInt(this.$route.query.board);
          } else this.selectedBoardId = this.boards[0]?.id;

          this.getSchoolSecretKeys();
        })

        .catch((err) => {
          ElNotification.error({
            message: err.response.data.message || "Doskalar yuklanmadi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getSchoolSecretKeys();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    downloadFile() {
      this.loading = true;
      this.$http
        .get(`api/v1/my-school/secret-keys/excel`, {
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
        .replace({
          query: { ...this.$route.query, size: val },
        })
        .then(() => {
          this.getSchoolSecretKeys();
        })
        .catch(() => {});
    },
    handleCurrentChange(val) {
      this.$router
        .replace({
          query: { ...this.$route.query, page: val },
        })
        .then(() => {
          this.getSchoolSecretKeys();
        })
        .catch(() => {});
    },
    getSchoolSecretKeys() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
        ? parseInt(this.$route.query.size || "")
        : this.size;

      this.$http
        .get(`api/v1/my-school/secret-keys`, {
          params: {
            limit: this.size,
            offset: (this.page - 1) * this.size,
            board_id: this.selectedBoardId,
          },
        })
        .then(({ data }) => {
          this.dataList = data.secret_keys;
          this.totalElements = data.count;
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showExcelModal() {
      this.excelModalVisible = true;
      this.getBoards();
    },
    handleClose() {
      this.excelModalVisible = false;
      this.excelForm = {
        board_id: null,
        intention: "MY_SCHOOL_PHONE_NUMBER_CHANGE",
        from_date: null,
        to_date: null,
        application_status: null,
      };
      if (this.$refs.excelForm) {
        this.$refs.excelForm.clearValidate();
      }
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/my-school/secret-keys/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Muvaffaqqiyatli o'chirildi",
              });
              this.getSchoolSecretKeys();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1;
    },
  },
  mounted() {
    this.getBoards();
  },
};
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-select
          v-model="selectedBoardId"
          style="margin-right: 10px; min-width: 300px"
          @change="onChangeBoard"
        >
          <el-option
            v-for="board in boards"
            :key="board.id"
            :value="board.id"
            :label="
              board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
            "
          />
        </el-select>
        <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeader"
          :data="{ board_id: this.selectedBoardId }"
          :multiple="false"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
        >
          <template #trigger>
            <el-button style="width: 100%" type="primary">
              Excel orqali kiritish
            </el-button>
          </template>
        </el-upload>
        <el-button type="success" @click="downloadFile"
          ><img
            src="@/assets/images/icons/download.svg"
            alt=""
            style="margin-right: 5px"
          />
          Kalitlarni yuklab olish
        </el-button>
      </div>
      <div style="display: flex; gap: 5px">
        <el-button type="success" @click="showExcelModal">
          Modifikatsiya tarixi
        </el-button>

        <router-link to="secret-keys/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <el-table
      :data="dataList"
      class="table"
      border
      height="calc(100vh - 235px)"
    >
      <el-table-column type="index" :index="indexMethod" width="80" label="#" />
      <el-table-column prop="secret" label="Kalit nomi" min-width="120" />
      <el-table-column
        prop="created_at"
        label="Yaratilgan vaqti"
        min-width="180"
      >
        <template v-slot="scope">
          {{ $moment(scope.row.created_at).format("YYYY-MM-DD | hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" width="115" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              $router.push({
                name: 'KeyFormEdit',
                params: { id: scope.row.id },
              })
            "
            ><img
              height="15"
              src="@/assets/images/icons/edit.svg"
              alt="action"
            />
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="onClickDelete(scope.row.id)"
          >
            <img
              height="15"
              src="@/assets/images/icons/delete.svg"
              alt="action"
            />
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
            v-model:current-page="currentPage"
            class="pagination"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="sizes, prev, pager, next"
            :total="totalElements"
            v-model:page-size="size"
            :page-count="totalPages"
            :background="true"
            :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>

  <!-- Excel Modal -->
  <el-dialog
    v-model="excelModalVisible"
    title="Modifikatsiya tarixini yuklash"
    width="500"
    :before-close="handleClose"
  >
    <el-form
      ref="excelForm"
      :model="excelForm"
      :rules="excelRules"
      label-position="top"
    >
      <el-form-item label="Doskani tanlang" prop="board_id">
        <el-select
          size="large"
          placeholder="Doskani tanlang"
          v-model="excelForm.board_id"
          style="width: 100%"
        >
          <el-option
            v-for="board in boards"
            :key="board.id"
            :value="board.id"
            :label="
              board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
            "
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Intention" prop="intention">
        <el-select
          size="large"
          placeholder="Intention"
          v-model="excelForm.intention"
          style="width: 100%"
        >
          <el-option
            v-for="intention in intentions"
            :key="intention.value"
            :value="intention.value"
            :label="intention.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Sana oralig'i" prop="from_date">
        <el-date-picker
          size="large"
          type="daterange"
          range-separator="To"
          start-placeholder="Boshlanish sanasi"
          end-placeholder="Tugash sanasi"
          v-model="dateRange"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="Holatni tanlang" prop="application_status">
        <el-select
          size="large"
          placeholder="Holatni tanlang"
          v-model="excelForm.application_status"
          style="width: 100%"
        >
          <el-option
            v-for="application_status in application_statuses"
            :key="application_status.value"
            :value="application_status.value"
            :label="application_status.label"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose">Bekor qilish</el-button>
        <el-button type="primary" @click="onSubmitExcel" :loading="loading"> Yuklash </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.filters {
  display: flex;
  gap: 10px;
}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
